module.exports = __webpack_public_path__ + "static/img/logo.930807c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 248
// module chunks = 1